import { Button, MultiSelect, Select, Text } from "@mantine/core";
import Page from "../../components/layout/Page";
import { useFetch } from "../../helpers/useFetch";
import { useLoaderData } from "react-router-dom";
import { getMode, parseFullName } from "../../helpers/helpers";
import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import {
  IconAddressBook,
  IconBookmark,
  IconBus,
  IconDoorExit,
  IconDownload,
  IconEdit,
  IconListDetails,
  IconSwitchHorizontal,
  IconUser,
  IconUserPlus,
} from "@tabler/icons-react";
import dayjs from "dayjs";
import Table from "../../components/table/core/Table.jsx";
import {
  openAddStaffModal,
  openChildTransferModal,
  openEarlyLeaveModal,
  openExportContactsModal,
  openTransportBuyModal,
} from "../../helpers/modals.js";
import useTitle from "../../hooks/useTitle";
import { useUser } from "../../providers/UserProvider";
import { usePermissions } from "../../providers/PermissionsProvider.jsx";
import { sortStaff } from "../../components/table/sort";

export const loader = async () => {
  return useFetch(`staff`);
};

export default function StaffOverviewPage() {
  const staff = useLoaderData().data;
  const { user } = useUser();
  const { hasPermission } = usePermissions();
  const { mode, theme } = getMode();

  const actionIcons = [
    ...(hasPermission("staff.privileges.edit")
      ? [
          {
            name: "Přidat do personálu",
            onTrigger: (e) => {
              e.stopPropagation();
              openAddStaffModal();
            },
            primary: true,
            icon: IconUserPlus,
          },
        ]
      : []),
    {
      name: "Stáhnout přehled personálu",
      onTrigger: (e) => {
        e.stopPropagation();
        const url = import.meta.env.VITE_API_URL + "/export/pdf/staff";
        const downloadLink = document.createElement("a");
        downloadLink.target = "_blank";
        downloadLink.href = new URL(url + "?_token=" + user.token, import.meta.env.VITE_API_URL).href;
        downloadLink.click();
      },
      primary: false,
      icon: IconDownload,
    },
    {
      name: "Exportovat kontakty",
      onTrigger: (e) => {
        e.stopPropagation();
        openExportContactsModal(staff);
      },
      primary: false,
      icon: IconAddressBook,
    },
  ];

  const columns = [
    {
      accessor: "name",
      title: "Jméno",
      render: (user) => parseFullName(user),
      sortable: true,
    },
    {
      accessor: "phone",
      title: "Telefon",
      render: (user) => (
        <Text className="w-fit hover:underline" color={theme.colors[theme.primaryColor][4]}>
          <a href={`tel:${user.phone}`}>{user.phone}</a>
        </Text>
      ),
    },
    {
      accessor: "position",
      title: "Funkce",
      render: (user) => user.position,
      sortable: true,
    },
    {
      accessor: "age",
      title: "Věk",
      render: (user) => user.age,
      sortable: true,
    },
  ];

  const filterConfig = [
    {
      key: "jmeno",
      label: "Jméno",
      type: "search",
      function: (user, value) => {
        return parseFullName(user).toLowerCase().includes(value.toLowerCase());
      },
    },
  ];

  useTitle("Přehled personálu");

  return (
    <Page title="Přehled personálu" actionIcons={actionIcons}>
      <Table filterConfig={filterConfig} columns={columns} records={staff} id="staff" sortFunction={sortStaff} />
    </Page>
  );
}
